import type { Entry, UnresolvedLink } from 'contentful';
import Link from 'components/shared/Link/Link';
import { SubnavLinkSkeleton, SubnavProps } from './types';
import { Colorways } from 'types/constants';
import { getSectionProps } from 'utils/styles';

// The REST client's default link-resolution chain leaves links to unpublished or
// archived entries as raw Link objects (no `fields`), not `undefined` — the
// `WITHOUT_UNRESOLVABLE_LINKS` field type understates this, so the guard input is
// widened to `UnresolvedLink` to make the structural `'fields' in item` check
// type-meaningful. A plain `.filter(Boolean)` would keep the truthy raw ref and
// then crash on `item.fields.url`. Mirrors components/shared/Media/toMediaAsset.ts.
const isResolvedSubnavLink = (
  item: Entry<SubnavLinkSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'> | UnresolvedLink<'Entry'> | undefined,
): item is Entry<SubnavLinkSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'> => item != null && 'fields' in item;

export const Subnav = (props: SubnavProps) => {
  const { sectionName } = props.fields;
  // Contentful omits a multi-reference field that has zero entries, so at runtime `links`
  // can be absent (not `[]`) — e.g. an unfinished draft subnav — despite its required type.
  const links = (props.fields.links ?? []).filter(isResolvedSubnavLink);
  const color = Colorways.Inverse;

  return (
    <section {...getSectionProps(color, undefined, sectionName)}>
      <nav
        className={`flex sm:justify-center gap-8 md:gap-16 py-6 font-serif overflow-x-auto no-scrollbar text-nowrap text-body-serif leading-[1.225rem]`}>
        {links.map(item => (
          <Link
            key={item.sys.id}
            href={item.fields.url}
            isSubnav={true}
            className="first:pl-6 sm:first:pl-10 last:pr-6 sm:last:pr-10 hover:text-fern focus:text-fern">
            {item.fields.text} ›
          </Link>
        ))}
      </nav>
    </section>
  );
};

export default Subnav;
